/*
 * @Descripttion:
 * @Author: weitongxue
 */
import { ref, watch } from 'vue';
import { fuzzyQueryUser, fuzzyQueryAllUser, fuzzyQueryUserBySSO } from '@/api/auth-manage/user/index';
import { UserItem, IUserSSOItem } from '@/api/auth-manage/user/type.d';
import { IAddUserInfoParams } from '@/api/manage-app/user-info/index.d';
import { APP_USER_SOURCE } from '@/constant';

export function useFuzzyQueryUser(isAllUser?: boolean, formData?: {value: IAddUserInfoParams; }) {
  const userList = ref<UserItem[]>([]);
  const fuzzyQueryUserLoading = ref(false);
  const copyKeyWord = ref<string>('');

  watch(() => formData?.value.dataChannel, () => {
    userList.value = [];
  }, { immediate: true });

  const handleFuzzyQueryUser = async (keyword: string) => {
    keyword = keyword.trim();
    copyKeyWord.value = keyword;
    try {
      if (!keyword) {
        userList.value = [];
        return;
      }
      fuzzyQueryUserLoading.value = true;
      let data: UserItem[] = [];
      if (formData?.value.dataChannel === APP_USER_SOURCE.SSO) {
        const res = await fuzzyQueryUserBySSO({
          systemCode: 'OPS',
          username: keyword,
        });
        data = res?.data.map((item: IUserSSOItem) => ({
          bbCode: item.userCode,
          name: item.username,
          userId: item.userId,
        })) || [];
      } else {
        const api = isAllUser ? fuzzyQueryAllUser : fuzzyQueryUser;
        const res = await api(keyword);
        data = res?.data || [];
      }

      userList.value = data;
    } catch (error) {
      console.error(error);
      if (error && error.isCancel) {
        setTimeout(() => {
          fuzzyQueryUserLoading.value = true;
        });
      }
    } finally {
      fuzzyQueryUserLoading.value = false;
    }
  };

  return {
    userList,
    fuzzyQueryUserLoading,
    handleFuzzyQueryUser,
    copyKeyWord,
  };
}
